<template>
  <div>
    <div>
      <riderEditViews :rider="riders"></riderEditViews>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import riderEditViews from "@/components/back-office/Rider/RiderEditViews.vue";
export default {
  components: {
    riderEditViews,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href:
        //    "/weserve_admin_login/control/" +
        //   this.$route.params.province +
        //   "/rider/riderdashboard"
      },
      {
        text: "Rider management",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
      },
      {
        text: "Edit rider detail",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {
    ...mapState({
      riders: (state) => state.fetchRiderListBack.rider,
    }),
  },
};
</script>
